import request from '@/utils/request'

export default {
  /**
   * 手写识别
   * @param data
   */
  handWriteRecognize(data) {
    return request.post('/hang-word/single/hand', data)
  }
}
